<template>
  <v-sheet elevation="3">
    <v-form v-model="valid">
      <v-container>
        <h2>Import Membres - Points Ratio - {{ businessData.comoBusinessId}}</h2>
        <v-row>
          <v-col cols="auto">
            <v-text-field
                v-model="pointsCalc.pointsByRewardItems"
                label="Points By Reward Items"
                persistent-hint
                type="number"
                required
                :rules="validationRules"
            ></v-text-field>
            <v-text-field
                v-model="pointsCalc.pointsByRewardPurchases"
                label="Points By Reward Purchases"
                type="number"
                required
                :rules="validationRules"
            ></v-text-field>
            <v-text-field
                v-model="pointsCalc.pointsByRewardVisits"
                label="Points By Reward Visits"
                type="number"
                required
                :rules="validationRules"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="justify-center">
          <v-btn
              :disabled="!valid || isRunning"
              :loading="isRunning"
              color="success"
              class="ma-2 white--text"
              @click="generateImportCsv(businessData, pointsCalc)"
          >
            Generate Import File
            <v-icon
                right
                dark
            >
              mdi-database-import
            </v-icon>
          </v-btn>
        </v-row>

      </v-container>
    </v-form>
  </v-sheet>

</template>

<script>
import revelRestaurantApi from "@/api/restaurant.api";

export default {
  name: "ImportMembersForm",
  mounted(){
    this.businessData = this.$attrs.businessData;
  },
  data: () => ({
    businessData: {
    },
    pointsCalc: {
      pointsByRewardItems: 1,
      pointsByRewardPurchases: 1,
      pointsByRewardVisits: 1,
    },
    validationRules: [
      v => !!v || 'Field is required',
      v=> v > 0 || 'bigger than 0',
    ],
    valid: false,
    isRunning: false,
  }),
  methods: {
    async generateImportCsv(business, pointsCalc) {
      this.isRunning = true;
      const res = await revelRestaurantApi.generateImportCsv(business.comoBusinessId, pointsCalc);
      console.log(res);
      if (res.error) {
        alert(`Failed generating file for ${business.comoBusinessId}, please try again. error: ${res.error}`);
        this.isRunning = false;
      }
      else if (res.data) {
        this.$set(business, 'downloadId', res.data.id);
        this.isRunning = false;
        this.$emit("importStarted", business);
      }
    },
  }
}
</script>

<style scoped>

</style>
